export default __webpack_public_path__ + "static/media/offer-icon-unpublished.87e0178c.svg";